import React, { Component }  from 'react';
import PropTypes from 'prop-types';

export default class NoResults extends Component {
    static propTypes = {
        inputValue: PropTypes.string
    };

    render() {
        return (
            <div className="no-results">
                <div className="no-results-header-container">
                    <div className="prefix-text">
                        Search results for
                    </div>
                    <div className="search-text-value">
                        {this.props.inputValue}
                    </div>
                </div>
                <div className="no-results-body-container">
                    <div>
                        No results
                    </div>
                </div>
            </div>
        );
    }
}
